import React from "react"
import { Field, Form } from "react-final-form"

import { styled } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { LoginWithKeycodeErrorHelperText } from "./ErrorHelperText"
import { LoginWithKeycodeFormFieldNames } from "./types"
import { useLoginWithKeycode } from "./useLoginWithKeycode"
import { useCustomerInfo } from "../../../CustomerInfo"
import {
  FormTitle, PasswordField, StyledLoginForm, SubmitButton, TextField
} from "../../components"
import { Grid } from "../../containers"

const KEYCODE_INPUT_ID = "keycode-input-id"

export const LoginWithKeycodeForm = () => {
  const { i18n } = useTranslations()
  const { handleLogin, error, submitting, cleanError } = useLoginWithKeycode()
  const customerInfo = useCustomerInfo()

  return <Form onSubmit={handleLogin}
               render={({ handleSubmit, values }) => <StyledLoginForm
                 onSubmit={handleSubmit}>
                 <Grid>
                   <FormTitle sx={{ marginBottom: "10px" }}>
                     {`${i18n("Account.Login:LoginWith")} ${i18n("Account.Login:Keycode")}`}
                   </FormTitle>

                   <FieldsContainer>
                     {customerInfo.data?.keycode?.requireUsername &&
                         <Field name={LoginWithKeycodeFormFieldNames.username}>
                           {({ input }) => <TextField
                             {...input} type="text" width="auto" autoComplete="off"
                             placeholder={i18n("Login:Username")}
                             label={i18n("Login:Username")}
                             error={!!error}
                             id={LOGIN_INPUT_ID}
                             inputProps={{
                               "aria-labelledby": LOGIN_INPUT_ID
                             }}
                             disabled={submitting} onChange={(event) => {
                             !!error && cleanError()
                             input.onChange(event)
                           }}/>}
                         </Field>}

                     <PasswordField name={LoginWithKeycodeFormFieldNames.keycode} textFieldProps={{
                       error: !!error,
                       helperText: !!error && <LoginWithKeycodeErrorHelperText error={error.error}/>,
                       disabled: submitting,
                       placeholder: i18n("Account.Login:KeycodePlaceholder"),
                       executeOnChange: cleanError,
                       id: KEYCODE_INPUT_ID
                     }}/>
                   </FieldsContainer>
                 </Grid>

                 <Grid>
                   <SubmitButton label={i18n("Account.Login:Login")} type="submit"
                                 isLoading={submitting}
                                 disabled={submitting || !!error || !values.keycode?.trim()}/>
                 </Grid>
               </StyledLoginForm>}/>
}

const FieldsContainer = styled("div")({
  display: "grid", rowGap: "30px", padding: "16px 0"
})

const LOGIN_INPUT_ID = "login-input-id"
